import React from 'react';
import './index.scss';
import PcConfOdItem from '../PcConfOdItem';

const PcConfTitle = ({
  text,
  list = [],
  icon,
  comment,
}) => {
  const svgDir = require.context("!@svgr/webpack!assets/");

  const Icon = svgDir(`./${icon}.svg`).default;

  // const DispIcon = () => {
  //   return (
  //     <span className="">
  //       <img className="icon" src={require(`assets/${icon}.svg`)} alt="" />
  //     </span>
  //   );
  // };

  const ShowList = ({ list: detail }) => {
    return (
      <div className="">
        {detail.map(data => (
          <span key={data.text} className="">
            <PcConfOdItem
              text={data.text}
              children={data.children}
              changeModifyMode={data.modifyLinks}
            />
          </span>
        ),
        )}
      </div>
    );
  };

  return (
    <div className="PcConfTitle">
      <div className="PITM-title">
        <div className="PITM-iconArea">
          {/* <DispIcon /> */}
          <span className="icon">
            <Icon/>
          </span>
        </div>
        <div className="PITM-titleArea">
          <p className="title">{text}</p>
        </div>
      </div>
      <div className="odArea">
        <ShowList list={list} />
      </div>
      <div className="commentArea">
        {comment}
      </div>
      <div className="horizontalLine" />
    </div>
  );
};

export default PcConfTitle;